'use strict'

require 'optimize-suite'
{ parsed, loaded } = require '../../../src/frontend/core/browser_events'

{Optimize} = window
{config} = Optimize.suiteData
config.finch = config: Optimize.finchConfig
Optimize.config = config
OptimizeSuite.init config

parsed.then ->
  OptimizeSuite.initBloodhound() unless Optimize.delayBloodhound

loaded.then ->
  setTimeout (->
    if Optimize.delayBloodhound
      OptimizeSuite.initBloodhound()
  ), 0
